[
  "session.signUp",
  "session.confirm",
  "session.resendConfirmation",
  "session.signIn",
  "session.answerChallenge",
  "session.refresh",
  "session.signOut",
  "session.forgotPassword",
  "session.resetPassword",
  "session.changePassword",
  "factor.enrolStart",
  "factor.enrolVerify",
  "invitation.preview",
  "invitation.accept",
  "invitation.checkStatus",
  "invitation.create",
  "invitation.revoke",
  "verification.confirm",
  "identity.repair",
  "organisation.update",
  "user.changeRole",
  "user.deactivate",
  "user.reactivate",
  "user.resetFactor",
  "user.replaceGrants",
  "user.revokeGrants",
  "recipient.create",
  "recipient.delete",
  "recipient.resendVerification",
  "subscription.replace",
  "workspace.connect",
  "workspace.update",
  "workspace.disconnect",
  "workspace.completeOnboarding",
  "credential.replace",
  "scope.replace",
  "schedule.replace",
  "retention.replace",
  "repositories.refresh",
  "connection.create",
  "connection.activate",
  "connection.deactivate",
  "scopeCheck.start",
  "scopeCheck.acknowledgeGaps",
  "job.trigger",
  "job.cancel",
  "job.note.add",
  "restore.plan",
  "restore.proposePrincipalMap",
  "restore.confirm",
  "restore.trigger",
  "restore.cancel",
  "restore.note.add",
  "securedValue.update",
  "alert.acknowledge",
  "alert.snooze",
  "alert.resolve",
  "report.export",
  "drift.export",
  "organisationAudit.export",
  "workspaceAudit.export",
  "restoreObjects.export",
  "securedValues.export",
  "backupLogs.export",
  "restoreLogs.export"
]
